import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "dashboard-area pt-120 mb-120" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row g-lg-4 gy-5 mb-90" }
const _hoisted_4 = { class: "col-lg-9" }
const _hoisted_5 = { class: "my-profile-inner" }
const _hoisted_6 = { class: "form-wrapper mb-60" }
const _hoisted_7 = { class: "profile-form" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = { class: "form-inner mb-25" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "Full Name*", -1)
const _hoisted_12 = { class: "input-area" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/user-2.svg",
  alt: ""
}, null, -1)
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-inner mb-25" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", null, "Gender", -1)
const _hoisted_17 = { class: "input-area" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/language-2.svg",
  alt: ""
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Gender", -1)
const _hoisted_20 = ["selected"]
const _hoisted_21 = ["selected"]
const _hoisted_22 = ["selected"]
const _hoisted_23 = { class: "col-md-12" }
const _hoisted_24 = { class: "form-inner mb-25" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", null, "Your DOB", -1)
const _hoisted_26 = { class: "input-area" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/clock-2.svg ",
  alt: ""
}, null, -1)
const _hoisted_28 = { class: "col-md-12" }
const _hoisted_29 = { class: "form-inner mb-50" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", null, "Street", -1)
const _hoisted_31 = { class: "col-md-12" }
const _hoisted_32 = { class: "form-inner mb-25" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", null, "Location", -1)
const _hoisted_34 = { class: "input-area" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/company-2.svg",
  alt: ""
}, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Location", -1)
const _hoisted_37 = ["value", "selected"]
const _hoisted_38 = { class: "col-md-6" }
const _hoisted_39 = { class: "form-inner mb-25" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", null, "Country", -1)
const _hoisted_41 = { class: "input-area" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/company-2.svg",
  alt: ""
}, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Location", -1)
const _hoisted_44 = ["value", "selected"]
const _hoisted_45 = { class: "col-md-6" }
const _hoisted_46 = { class: "form-inner mb-25" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", null, "Phone Number*", -1)
const _hoisted_48 = { class: "input-area" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/phone-2.svg",
  alt: ""
}, null, -1)
const _hoisted_50 = { class: "col-md-6" }
const _hoisted_51 = { class: "form-inner mb-25" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("label", null, "Email*", -1)
const _hoisted_53 = { class: "input-area" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/email-2.svg",
  alt: ""
}, null, -1)
const _hoisted_55 = { class: "col-md-6" }
const _hoisted_56 = { class: "form-inner mb-25" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", null, "Job Title*", -1)
const _hoisted_58 = { class: "input-area" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/designation-2.svg",
  alt: ""
}, null, -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Job Title", -1)
const _hoisted_61 = ["value", "selected"]
const _hoisted_62 = { class: "col-md-6" }
const _hoisted_63 = { class: "form-inner mb-25" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", null, "Education", -1)
const _hoisted_65 = { class: "input-area" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/qualification-2.svg",
  alt: ""
}, null, -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Education", -1)
const _hoisted_68 = ["label"]
const _hoisted_69 = ["value", "selected"]
const _hoisted_70 = { class: "col-md-6" }
const _hoisted_71 = { class: "form-inner mb-25" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("label", null, "Select Availability", -1)
const _hoisted_73 = { class: "input-area" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/qualification-2.svg",
  alt: ""
}, null, -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Availability", -1)
const _hoisted_76 = ["value", "selected"]
const _hoisted_77 = { class: "col-md-6" }
const _hoisted_78 = { class: "form-inner mb-25" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("label", { for: "password2" }, "Upload Resume", -1)
const _hoisted_80 = { class: "input-area" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/create-resume.svg",
  alt: "",
  width: "16"
}, null, -1)
const _hoisted_82 = { key: 0 }
const _hoisted_83 = { class: "col-md-12" }
const _hoisted_84 = { class: "form-inner mb-50" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("label", null, "Description - Write a brief summary about you", -1)
const _hoisted_86 = { class: "col-lg-12" }
const _hoisted_87 = { class: "company-images-area mb-50" }
const _hoisted_88 = { class: "row g-lg-4 gy-5" }
const _hoisted_89 = { class: "col-lg-6 devaider1 position-relative" }
const _hoisted_90 = { class: "company-logo-area" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("h5", null, "Upload Display Picture: ", -1)
const _hoisted_92 = { class: "drag-area" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("p", null, "Upload Logo", -1)
const _hoisted_94 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "upload-btn"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-lg" })
], -1)
const _hoisted_95 = /*#__PURE__*/_createElementVNode("span", null, "Maximum File Upload: 2 MB", -1)
const _hoisted_96 = { class: "col-lg-6" }
const _hoisted_97 = ["src"]
const _hoisted_98 = ["src"]
const _hoisted_99 = { class: "col-md-12" }
const _hoisted_100 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("h6", null, "Casual Portal Visibility", -1)
const _hoisted_102 = { class: "form-check form-switch mt-2" }
const _hoisted_103 = { class: "visibility-status-label" }
const _hoisted_104 = { class: "col-md-12 mb-5" }
const _hoisted_105 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("h6", null, "Employee Directory Visibility", -1)
const _hoisted_107 = { class: "form-check form-switch mt-2" }
const _hoisted_108 = { class: "visibility-status-label" }
const _hoisted_109 = { class: "col-md-12" }
const _hoisted_110 = { class: "form-inner" }
const _hoisted_111 = {
  key: 1,
  class: "primry-btn-2 lg-btn w-unset",
  type: "button"
}
const _hoisted_112 = /*#__PURE__*/_createElementVNode("span", { class: "me-3 fs-6 text-white" }, "Processing...", -1)
const _hoisted_113 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-spinner fa-spin text-white ms-3",
  style: {"font-size":"24px"}
}, null, -1)
const _hoisted_114 = [
  _hoisted_112,
  _hoisted_113
]
const _hoisted_115 = { class: "form-wrapper mt-5" }
const _hoisted_116 = { class: "profile-form" }
const _hoisted_117 = /*#__PURE__*/_createElementVNode("div", { class: "section-title2" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "d-flex align-items-baseline gap-1" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "assets/images/icon/profile-settings.svg",
      alt: ""
    }),
    /*#__PURE__*/_createTextVNode(" Upload Documents ")
  ])
], -1)
const _hoisted_118 = { class: "change-password-area mb-40" }
const _hoisted_119 = { class: "row" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "info-title" }, [
    /*#__PURE__*/_createElementVNode("h6", null, "You can upload your leagal documents here"),
    /*#__PURE__*/_createElementVNode("div", { class: "dash" })
  ])
], -1)
const _hoisted_121 = { class: "col-md-12" }
const _hoisted_122 = { class: "form-inner mb-25" }
const _hoisted_123 = /*#__PURE__*/_createElementVNode("label", null, "Document Name", -1)
const _hoisted_124 = { class: "input-area" }
const _hoisted_125 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/education.svg",
  alt: "",
  width: "16"
}, null, -1)
const _hoisted_126 = { class: "col-md-12" }
const _hoisted_127 = { class: "form-inner mb-25" }
const _hoisted_128 = /*#__PURE__*/_createElementVNode("label", { for: "password2" }, "Document Detail*", -1)
const _hoisted_129 = { class: "col-md-12" }
const _hoisted_130 = { class: "form-inner mb-25" }
const _hoisted_131 = /*#__PURE__*/_createElementVNode("label", { for: "password2" }, "Upload File*", -1)
const _hoisted_132 = { class: "input-area" }
const _hoisted_133 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/create-resume.svg",
  alt: "",
  width: "16"
}, null, -1)
const _hoisted_134 = { class: "col-md-12 pt-10" }
const _hoisted_135 = { class: "form-inner" }
const _hoisted_136 = {
  key: 1,
  class: "primry-btn-2 lg-btn w-unset",
  type: "button"
}
const _hoisted_137 = /*#__PURE__*/_createElementVNode("span", { class: "me-3 fs-6 text-white" }, "Processing...", -1)
const _hoisted_138 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-spinner fa-spin text-white ms-3",
  style: {"font-size":"24px"}
}, null, -1)
const _hoisted_139 = [
  _hoisted_137,
  _hoisted_138
]
const _hoisted_140 = { class: "form-wrapper" }
const _hoisted_141 = /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Social Network:")
], -1)
const _hoisted_142 = { class: "profile-form" }
const _hoisted_143 = { class: "row" }
const _hoisted_144 = { class: "col-md-6" }
const _hoisted_145 = { class: "form-inner mb-25" }
const _hoisted_146 = /*#__PURE__*/_createElementVNode("label", null, "Facebook", -1)
const _hoisted_147 = { class: "input-area" }
const _hoisted_148 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/facebook-2.svg",
  alt: ""
}, null, -1)
const _hoisted_149 = { class: "col-md-6" }
const _hoisted_150 = { class: "form-inner mb-25" }
const _hoisted_151 = /*#__PURE__*/_createElementVNode("label", null, "Twitter", -1)
const _hoisted_152 = { class: "input-area" }
const _hoisted_153 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/twiter-2.svg",
  alt: ""
}, null, -1)
const _hoisted_154 = { class: "col-md-6" }
const _hoisted_155 = { class: "form-inner mb-25" }
const _hoisted_156 = /*#__PURE__*/_createElementVNode("label", null, "LinkedIn", -1)
const _hoisted_157 = { class: "input-area" }
const _hoisted_158 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/linkedin-2.svg",
  alt: ""
}, null, -1)
const _hoisted_159 = { class: "col-md-6" }
const _hoisted_160 = { class: "form-inner mb-25" }
const _hoisted_161 = /*#__PURE__*/_createElementVNode("label", null, "Instagram", -1)
const _hoisted_162 = { class: "input-area" }
const _hoisted_163 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/instagram.svg",
  alt: "",
  width: "16"
}, null, -1)
const _hoisted_164 = { class: "col-md-12" }
const _hoisted_165 = { class: "form-inner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_user_menu = _resolveComponent("user-menu")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_user_menu),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("form", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("div", _hoisted_12, [
                        _hoisted_13,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.name) = $event)),
                          type: "text"
                        }, null, 512), [
                          [_vModelText, _ctx.user.name]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _withDirectives(_createElementVNode("select", {
                          class: "form-select",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.gender) = $event))
                        }, [
                          _hoisted_19,
                          _createElementVNode("option", {
                            value: "male",
                            selected: _ctx.user.gender == 'male'
                          }, "Male", 8, _hoisted_20),
                          _createElementVNode("option", {
                            value: "female",
                            selected: _ctx.user.gender == 'female'
                          }, "Female ", 8, _hoisted_21),
                          _createElementVNode("option", {
                            value: "unspecified",
                            selected: _ctx.user.gender == 'unspecified'
                          }, " Unspecified", 8, _hoisted_22)
                        ], 512), [
                          [_vModelSelect, _ctx.user.gender]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _createElementVNode("div", _hoisted_26, [
                        _hoisted_27,
                        _createVNode(_component_Calendar, {
                          modelValue: _ctx.user.dob,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.dob) = $event)),
                          dateFormat: "dd-mm-yy",
                          maxDate: _ctx.maxDate
                        }, null, 8, ["modelValue", "maxDate"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.address) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.user.address]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      _createElementVNode("div", _hoisted_34, [
                        _hoisted_35,
                        _withDirectives(_createElementVNode("select", {
                          class: "form-select",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.user.location_id) = $event))
                        }, [
                          _hoisted_36,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.states, (state) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: state.id,
                              selected: _ctx.user.location_id == state.id
                            }, _toDisplayString(state.name), 9, _hoisted_37))
                          }), 256))
                        ], 512), [
                          [_vModelSelect, _ctx.user.location_id]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _hoisted_40,
                      _createElementVNode("div", _hoisted_41, [
                        _hoisted_42,
                        _withDirectives(_createElementVNode("select", {
                          class: "form-select",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.user.current_job_location_id) = $event))
                        }, [
                          _hoisted_43,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locationsOptions, (location) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: location.id,
                              selected: _ctx.user.current_job_location_id == location.id
                            }, _toDisplayString(location.name), 9, _hoisted_44))
                          }), 256))
                        ], 512), [
                          [_vModelSelect, _ctx.user.current_job_location_id]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _hoisted_47,
                      _createElementVNode("div", _hoisted_48, [
                        _hoisted_49,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.user.phone) = $event)),
                          type: "text"
                        }, null, 512), [
                          [_vModelText, _ctx.user.phone]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _hoisted_52,
                      _createElementVNode("div", _hoisted_53, [
                        _hoisted_54,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.user.email) = $event)),
                          type: "email",
                          readonly: ""
                        }, null, 512), [
                          [_vModelText, _ctx.user.email]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _hoisted_57,
                      _createElementVNode("div", _hoisted_58, [
                        _hoisted_59,
                        _withDirectives(_createElementVNode("select", {
                          class: "form-select",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.user.designation_id) = $event))
                        }, [
                          _hoisted_60,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.designationsOptions, (designation) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: designation.id,
                              selected: _ctx.user.designation_id == designation.id
                            }, _toDisplayString(designation.name), 9, _hoisted_61))
                          }), 256))
                        ], 512), [
                          [_vModelSelect, _ctx.user.designation_id]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, [
                      _hoisted_64,
                      _createElementVNode("div", _hoisted_65, [
                        _hoisted_66,
                        _withDirectives(_createElementVNode("select", {
                          class: "form-select",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.user.qualification_id) = $event))
                        }, [
                          _hoisted_67,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.degreeGroups, (group, index) => {
                            return (_openBlock(), _createElementBlock("optgroup", { label: index }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: item.id,
                                  selected: _ctx.user.qualification_id == item.id
                                }, _toDisplayString(item.name), 9, _hoisted_69))
                              }), 256))
                            ], 8, _hoisted_68))
                          }), 256))
                        ], 512), [
                          [_vModelSelect, _ctx.user.qualification_id]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_70, [
                    _createElementVNode("div", _hoisted_71, [
                      _hoisted_72,
                      _createElementVNode("div", _hoisted_73, [
                        _hoisted_74,
                        _withDirectives(_createElementVNode("select", {
                          class: "form-select",
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.user.availability_id) = $event))
                        }, [
                          _hoisted_75,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employeeAvailabilityList, (availability) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: availability.id,
                              selected: _ctx.user.availability_id == availability.id
                            }, _toDisplayString(availability.name), 9, _hoisted_76))
                          }), 256))
                        ], 512), [
                          [_vModelSelect, _ctx.user.availability_id]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("div", _hoisted_78, [
                      _hoisted_79,
                      _createElementVNode("div", _hoisted_80, [
                        _hoisted_81,
                        _createElementVNode("input", {
                          type: "file",
                          onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.cvHandle && _ctx.cvHandle(...args))),
                          placeholder: "upload file",
                          accept: ".pdf,application/pdf,image/jpeg,image/jpg,image/png,image/webp"
                        }, null, 32)
                      ]),
                      (_ctx.user.cv !== null)
                        ? (_openBlock(), _createElementBlock("label", _hoisted_82, "Resume already uploaded"))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_83, [
                    _createElementVNode("div", _hoisted_84, [
                      _hoisted_85,
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.user.description) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.user.description]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_86, [
                    _createElementVNode("div", _hoisted_87, [
                      _createElementVNode("div", _hoisted_88, [
                        _createElementVNode("div", _hoisted_89, [
                          _createElementVNode("div", _hoisted_90, [
                            _hoisted_91,
                            _createElementVNode("div", _hoisted_92, [
                              _hoisted_93,
                              _hoisted_94,
                              _createElementVNode("input", {
                                onChange: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.handlePhotoUpload && _ctx.handlePhotoUpload(...args))),
                                type: "file",
                                accept: ".jpg,.jpeg,.png,.webp,image/jpeg,image/jpg,image/png,image/webp"
                              }, null, 32)
                            ]),
                            _hoisted_95
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_96, [
                          (_ctx.logoVisible)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                width: "200",
                                src: _ctx.user.photo,
                                alt: ""
                              }, null, 8, _hoisted_97))
                            : _createCommentVNode("", true),
                          _createElementVNode("img", {
                            src: _ctx.preview,
                            width: "200",
                            alt: ""
                          }, null, 8, _hoisted_98)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_99, [
                    _createElementVNode("div", _hoisted_100, [
                      _hoisted_101,
                      _createElementVNode("div", _hoisted_102, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["visibility-switch-container", { disabled: _ctx.visibilityIsDisabled }])
                        }, [
                          _createElementVNode("span", _hoisted_103, _toDisplayString(_ctx.user.casual_portal_visibility ? "Visible" : "Not Visible"), 1),
                          _createVNode(_component_InputSwitch, {
                            modelValue: _ctx.user.casual_portal_visibility,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.user.casual_portal_visibility) = $event)),
                            pt: { slider: 'my-switch-slider' }
                          }, null, 8, ["modelValue"])
                        ], 2)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_104, [
                    _createElementVNode("div", _hoisted_105, [
                      _hoisted_106,
                      _createElementVNode("div", _hoisted_107, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["visibility-switch-container", { disabled: _ctx.visibilityIsDisabled }])
                        }, [
                          _createElementVNode("span", _hoisted_108, _toDisplayString(_ctx.user.employee_directory_visibility ? "Visible" : "Not Visible"), 1),
                          _createVNode(_component_InputSwitch, {
                            modelValue: _ctx.user.employee_directory_visibility,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.user.employee_directory_visibility) = $event)),
                            pt: { slider: 'my-switch-slider' }
                          }, null, 8, ["modelValue"])
                        ], 2)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_109, [
                    _createElementVNode("div", _hoisted_110, [
                      (!_ctx.isLoading)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.updateProfile && _ctx.updateProfile(...args))),
                            class: "primry-btn-2 lg-btn w-unset",
                            type: "button"
                          }, "Update Profile "))
                        : (_openBlock(), _createElementBlock("button", _hoisted_111, _hoisted_114))
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_115, [
              _createElementVNode("form", _hoisted_116, [
                _hoisted_117,
                _createElementVNode("div", _hoisted_118, [
                  _createElementVNode("div", _hoisted_119, [
                    _hoisted_120,
                    _createElementVNode("div", _hoisted_121, [
                      _createElementVNode("div", _hoisted_122, [
                        _hoisted_123,
                        _createElementVNode("div", _hoisted_124, [
                          _hoisted_125,
                          _createVNode(_component_Dropdown, {
                            modelValue: _ctx.documentForm.title,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.documentForm.title) = $event)),
                            options: _ctx.documents,
                            onChange: _ctx.setTitle,
                            ref: "suburb_id",
                            optionLabel: "name",
                            optionValue: "name",
                            placeholder: "Select Title",
                            class: "w-full md:w-24rem"
                          }, null, 8, ["modelValue", "options", "onChange"])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_126, [
                      _createElementVNode("div", _hoisted_127, [
                        _hoisted_128,
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.documentForm.detail) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.documentForm.detail]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_129, [
                      _createElementVNode("div", _hoisted_130, [
                        _hoisted_131,
                        _createElementVNode("div", _hoisted_132, [
                          _hoisted_133,
                          _createElementVNode("input", {
                            type: "file",
                            onChange: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.fileHandle && _ctx.fileHandle(...args))),
                            placeholder: "upload file"
                          }, null, 32)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_134, [
                      _createElementVNode("div", _hoisted_135, [
                        (!_ctx.isLoading)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.documentStore && _ctx.documentStore(...args))),
                              class: "primry-btn-2 lg-btn w-unset",
                              type: "button"
                            }, "Save Changes"))
                          : (_openBlock(), _createElementBlock("button", _hoisted_136, _hoisted_139))
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_140, [
              _hoisted_141,
              _createElementVNode("form", _hoisted_142, [
                _createElementVNode("div", _hoisted_143, [
                  _createElementVNode("div", _hoisted_144, [
                    _createElementVNode("div", _hoisted_145, [
                      _hoisted_146,
                      _createElementVNode("div", _hoisted_147, [
                        _hoisted_148,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.social.facebook) = $event)),
                          placeholder: "https://example-facebook.com"
                        }, null, 512), [
                          [_vModelText, _ctx.social.facebook]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_149, [
                    _createElementVNode("div", _hoisted_150, [
                      _hoisted_151,
                      _createElementVNode("div", _hoisted_152, [
                        _hoisted_153,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.social.twitter) = $event)),
                          placeholder: "https://example-twitter.com"
                        }, null, 512), [
                          [_vModelText, _ctx.social.twitter]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_154, [
                    _createElementVNode("div", _hoisted_155, [
                      _hoisted_156,
                      _createElementVNode("div", _hoisted_157, [
                        _hoisted_158,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.social.linkedin) = $event)),
                          placeholder: "https://example-linkedin.com"
                        }, null, 512), [
                          [_vModelText, _ctx.social.linkedin]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_159, [
                    _createElementVNode("div", _hoisted_160, [
                      _hoisted_161,
                      _createElementVNode("div", _hoisted_162, [
                        _hoisted_163,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.social.instagram) = $event)),
                          placeholder: "https://example-instagram.com"
                        }, null, 512), [
                          [_vModelText, _ctx.social.instagram]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_164, [
                    _createElementVNode("div", _hoisted_165, [
                      _createElementVNode("button", {
                        onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.updateUserSocial && _ctx.updateUserSocial(...args))),
                        class: "primry-btn-2 lg-btn w-unset",
                        type: "button"
                      }, "Update Social Info")
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}